import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { CHAT_DOMAIN, MODE } from '../../api/static.data.pnp';
import { urlApi } from '../../api/url.api';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { PROFILE } from '../../statics/localStorage';
import axios from "axios";
import { getDaysLeft } from '../../utils/dateTimeConverter';
import { IconBrandWhatsapp, IconMail, IconPhoneCall } from '@tabler/icons-react';

const PricingPlan = () => {
    const [planList, setPlanList] = useState([]);
    const [billingCycle, setBillingCycle] = useState('yearly');
    const [expanded, setExpanded] = useState({});
    const profileData = PROFILE();
    const [isIndia, setIsIndia] = useState(true);

    const toggleExpand = (planName) => {
        setExpanded((prev) => ({ ...prev, [planName]: !prev[planName] }));
    };

    const getPlans = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getPlanList);
        loadingHide();
        if (resp?.responseCode === 200) {
            let insertOperatorCount = resp?.data?.map((planData) => {
                if (planData?.name !== "FREE") {
                    return {
                        ...planData,
                        baseMonthly: planData.monthly,
                        baseYearly: planData.yearly,
                        isOffer: planData?.monthlyOfferPrice?.inr !== planData?.monthly?.inr && planData?.yearlyOfferPrice?.inr !== planData?.yearly?.inr,
                    }
                } else {
                    return planData;
                }
            });
            setPlanList(insertOperatorCount);
        } else {
            setPlanList([]);
        }
    }

    useEffect(() => {
        getPlans();
        return () => { }
    }, [])


    const handlePlanSelection = async (plan, billingCycle) => {
        loadingShow();
        const planId =
            billingCycle === 'monthly'
                ? plan?.monthlyId
                : plan?.yearlyId;

        let url = isIndia ? (urlApi.buyPlan) : (urlApi.buyPlanUSD);
        let resp = await getApi(url + planId + "/" + (plan.operatorCount || 1));
        loadingHide();
        if (resp?.responseCode === 200) {
            if (resp?.data) {
                window.open(resp.data, '_self', "width=500,height=1000")
            } else {
                toast.success(resp?.message);
                window.location.replace(MODE === "DEV" ? CHAT_DOMAIN : "https://chat.advy.me");
            }
        } else {
            toast.error(resp?.message)
        }
    };

    const handleIncreaseOperatorCount = (plan) => {
        const updatedPlans = planList.map((p) => {
            if (p.name === plan.name) {
                const baseMonthly = p.baseMonthly ?? p.monthly;
                const baseYearly = p.baseYearly ?? p.yearly;

                const incrementMonthly = { inr: (baseMonthly?.inr * 0.5), usd: (baseMonthly?.usd * 0.5) };
                const incrementYearly = { inr: (baseYearly?.inr * 0.5), usd: (baseYearly?.usd * 0.5) };
                return {
                    ...p,
                    baseMonthly,
                    baseYearly,
                    monthly: { inr: p.monthly?.inr + incrementMonthly?.inr, usd: p?.monthly?.usd + incrementMonthly?.usd },
                    yearly: { inr: p.yearly?.inr + incrementYearly?.inr, usd: p?.yearly?.usd + incrementYearly?.usd },
                    operatorCount: (p.operatorCount || 1) + 1
                };
            }
            return p;
        });

        setPlanList(updatedPlans);
    };

    const handleDecreaseOperatorCount = (plan) => {
        const updatedPlans = planList.map((p) => {
            if (p.name === plan.name) {
                const baseMonthly = p.baseMonthly ?? p.monthly;
                const baseYearly = p.baseYearly ?? p.yearly;
                const currentCount = p.operatorCount || 1;

                if (currentCount <= 1) return p;

                const decrementMonthly = { inr: (baseMonthly?.inr * 0.5), usd: (baseMonthly?.usd * 0.5) };
                const decrementYearly = { inr: (baseYearly?.inr * 0.5), usd: (baseYearly?.usd * 0.5) };

                const newMonthly = { inr: (Math.max(p.monthly?.inr - decrementMonthly?.inr, baseMonthly?.inr)), usd: (Math.max(p.monthly?.usd - decrementMonthly?.usd, baseMonthly?.usd)) };
                const newYearly = { inr: (Math.max(p.yearly?.inr - decrementYearly?.inr, baseYearly?.inr)), usd: (Math.max(p.yearly?.usd - decrementYearly?.usd, baseYearly?.usd)) };

                return {
                    ...p,
                    monthly: newMonthly,
                    yearly: newYearly,
                    operatorCount: currentCount - 1
                };
            }
            return p;
        });

        setPlanList(updatedPlans);
    };

    // const checkCountry = async () => {
    //     try {
    //         const response = await axios.get("https://ipapi.co/json/");
    //         const country = response?.data?.country_name;
    //         setIsIndia(country === "India");
    //     } catch (error) {
    //         console.error("Failed to fetch location", error);
    //         setIsIndia(false);
    //     }
    // }

    const checkCountry = async () => {
        try {
            const response = await axios.get("https://ipinfo.io/json?token=f9a9e5c0c640f9");
            const country = response?.data?.country; // e.g., "IN"
            setIsIndia(country === "IN");
        } catch (error) {
            console.error("Failed to fetch location", error);
            setIsIndia(false);
        }
    };

    useEffect(() => {
        checkCountry();
        return () => { }
    }, []);




    return (
        <Layout>


            <div className="bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">

                <div className="text-center mb-8">
                    <div className="text-center mb-8">
                        <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-2">
                            Live Chat Pricing Plans
                        </h2>
                        <h3 className="text-lg sm:text-xl text-gray-600 mb-1">
                            User-based plans that scale with your team
                        </h3>
                        {/* <p className="text-sm text-gray-500 italic"># 15-day free trial. No credit card required.</p> */}
                    </div>

                    <div className="inline-flex mt-4 items-center">
                        <span className="mr-2 text-gray-600">Billed Monthly</span>
                        <label className="inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                className="sr-only"
                                onChange={() =>
                                    setBillingCycle(billingCycle === 'yearly' ? 'monthly' : 'yearly')
                                }
                                checked={billingCycle === 'yearly'}
                            />
                            <div className="relative w-14 h-7 bg-gray-300 rounded-full shadow-inner transition">
                                <div
                                    className={`dot absolute w-7 h-7 rounded-full shadow-md transition transform ${billingCycle === 'yearly' ? 'translate-x-7 !bg-primary' : 'translate-x-0 bg-white'
                                        }`}
                                />
                            </div>
                        </label>
                        <span className="ml-2 text-gray-600">Billed Yearly</span>
                    </div>
                </div>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {planList?.map((plan) => (
                        <div
                            key={plan.name}
                            className={`rounded-2xl shadow-lg bg-white p-6 relative flex flex-col justify-between 
                                ${plan.popular ? 'border-4 border-blue-600' : 'border'}
                                `}
                        >
                            {plan.popular && (
                                <div className="absolute -top-3 right-3 text-white text-xs font-semibold px-2 py-1 !bg-primary rounded-md"
                                // style={{ backgroundImage: 'linear-gradient(to right, #FF671F, #FFFFFF,#046A38' }}
                                >
                                    Most Popular
                                    {/* Freedom Sale */}
                                </div>
                            )}
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800">{plan.name}</h3>
                                {/* <p className="mt-4 text-3xl font-bold text-gray-900">
                                    {isIndia ? "₹" : "$"}{billingCycle === 'yearly' ? (isIndia ? plan?.yearly?.inr : plan?.yearly?.usd) : (isIndia ? plan?.monthly?.inr : plan?.monthly?.usd)}
                                    <span className="text-sm font-medium text-gray-500"> /mo</span>
                                </p> */}
                                <p className="mt-4 text-3xl font-bold text-gray-900">
                                    {(() => {
                                        const isYearly = billingCycle === 'yearly';

                                        const actualPrice = isIndia
                                            ? (isYearly ? plan?.yearly?.inr : plan?.monthly?.inr)
                                            : (isYearly ? plan?.yearly?.usd : plan?.monthly?.usd);

                                        const offerPrice = isIndia
                                            ? (isYearly ? plan?.yearlyOfferPrice?.inr : plan?.monthlyOfferPrice?.inr)
                                            : (isYearly ? plan?.yearlyOfferPrice?.usd : plan?.monthlyOfferPrice?.usd);

                                        const currency = isIndia ? "₹" : "$";

                                        if (typeof offerPrice === 'number' && offerPrice < actualPrice && plan?.isOffer) {
                                            return (
                                                <>
                                                    <span className="line-through text-gray-500 mr-2 !text-xl">
                                                        {currency}{actualPrice}
                                                    </span>
                                                    {currency}{offerPrice}
                                                </>
                                            );
                                        }

                                        return `${currency}${actualPrice}`;
                                    })()}
                                    <span className="text-sm font-medium text-gray-500"> /mo</span>
                                </p>

                                <p className="text-sm text-gray-500 mt-1">
                                    billed {billingCycle}
                                </p>
                                {/* {
                                    plan?.operatorCount && <div className='flex items-center gap-3 flex-wrap'>
                                        <p className="text-sm text-gray-500 mt-2">Operators:</p>
                                        <div className="mt-2 flex items-center space-x-2">
                                            <button
                                                className="px-3 py-1 bg-gray-200 rounded-lg text-gray-700 hover:bg-gray-300 transition font-bold"
                                                onClick={() => handleDecreaseOperatorCount(plan)}
                                                disabled={plan.operatorCount <= 1}
                                            >
                                                -
                                            </button>
                                            <span className="text-lg font-semibold">{plan.operatorCount}</span>
                                            <button
                                                className="px-3 py-1 bg-gray-200 rounded-lg text-gray-700 hover:bg-gray-300 transition font-bold"
                                                onClick={() => handleIncreaseOperatorCount(plan)}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                } */}
                                <ul className="mt-6 space-y-2 text-sm text-gray-700">
                                    {/* {plan?.operatorCount && <li className="flex items-start">
                                        <span className="text-green-600 mr-2">✓</span>
                                        {plan?.operatorCount && `Up to ${plan.operatorCount} operators`}
                                    </li>} */}
                                    {plan.features.map((feature, idx) => (
                                        (plan?.operatorCount && feature.includes('operator license')) ? null :
                                            <li key={idx} className="flex items-start">
                                                <span className="text-green-600 mr-2">✓</span>
                                                {feature}
                                            </li>
                                    ))}
                                </ul>
                                {plan.extraFeatures && (
                                    <>
                                        <button
                                            className="mt-4 text-blue-600 text-sm font-semibold hover:underline focus:outline-none"
                                            onClick={() => toggleExpand(plan.name)}
                                        >
                                            {expanded[plan.name] ? 'See less' : 'See more'}
                                        </button>
                                        {expanded[plan.name] && (
                                            <div className="mt-3">
                                                <p className="text-sm text-gray-500 mb-2 font-medium">{plan.extraLabel}:</p>
                                                <ul className="space-y-2 text-sm text-gray-700">
                                                    {plan.extraFeatures.map((feature, idx) => (
                                                        <li key={idx} className="flex items-start">
                                                            <span className="text-green-600 mr-2">+</span>
                                                            {feature}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            <button className={`mt-6 w-full !bg-primary disabled:!bg-gray-700 py-2 rounded-lg hover:!bg-blue-800 transition`}
                                // style={{ backgroundImage: plan?.popular && 'linear-gradient(to right, #FF671F, #FFFFFF,#046A38', color: plan?.popular ? '#06038D' : 'white' }}
                                disabled={profileData?.currentPlanId == plan?.monthlyId || profileData?.currentPlanId == plan?.yearlyId} onClick={() => handlePlanSelection(plan, billingCycle)}>
                                {profileData?.currentPlanId == plan?.monthlyId || profileData?.currentPlanId == plan?.yearlyId ? `${getDaysLeft(profileData?.planEndDate) || 0} Day(s) Left` : "Try Now"}
                            </button>
                        </div>
                    ))}

                    {planList?.length > 0 && <div className='rounded-2xl shadow-lg bg-white p-6 relative flex flex-col justify-between'>
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800">ENTERPRISE</h3>

                            <p className="mt-4 text-xl font-bold text-gray-900">
                                Contact to Sales
                            </p>

                            <div className='flex flex-col gap-3 items-center justify-center h-full'>
                                <h6>Need something curated and
                                    specially created for your brand? </h6>

                                <h6>We hear you! Kindly contact our
                                    Sales Team, We’ll prepare the
                                    AI Powered Support System for you.  </h6>
                            </div>

                        </div>
                        <div className="flex items-center justify-center gap-3">
                            <a href={(() => {
                                const phoneNumber = "9147420975";
                                const message = "Hello! I want to know about the Enterprise Plan for my business.";
                                const encodedMessage = encodeURIComponent(message);
                                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                                return whatsappUrl;
                            })()} className='!bg-primary disabled:!bg-gray-700 p-2 rounded-lg hover:!bg-blue-800 transition' target="_blank"
                                rel="noopener noreferrer">
                                <IconBrandWhatsapp color='white' />
                            </a>
                            <a href="tel:9147420975" className='!bg-primary disabled:!bg-gray-700 p-2 rounded-lg hover:!bg-blue-800 transition' target="_blank"
                                rel="noopener noreferrer">
                                <IconPhoneCall color='white' />
                            </a>
                            <a href="mailto:sales@moina.ai?subject=Inquiry&body=Hello%2C%20I%20would%20like%20to%20know%20more..." className='!bg-primary disabled:!bg-gray-700 p-2 rounded-lg hover:!bg-blue-800 transition' target="_blank"
                                rel="noopener noreferrer">
                                <IconMail color='white' />
                            </a>
                        </div>
                    </div>}

                </div>
                <p className="text-sm mt-2 italic">*Local taxes (VAT, GST, etc.) are included in the prices mentioned.</p>
                {/* Why Choose Attriva Section */}
                <div className="max-w-6xl mx-auto mt-16 text-center">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4">Why Choose Attriva Live Chat?</h3>
                    <ul className="space-y-2 text-gray-700 text-sm sm:text-base text-left mx-auto max-w-2xl">
                        <li>✅ <b>Rapid Setup:</b> Integrate with your website/app in minutes</li>
                        <li>✅ <b>Website Scan:</b> AI learns from your site to answer customer queries instantly</li>
                        <li>✅ <b>Smart Handover:</b> AI connects visitors to real agents when needed</li>
                        <li>✅ <b>Live Chat & Calls:</b> Agents can chat or call visitors directly</li>
                        <li>✅ <b>Affordable for All Sizes:</b> Plans for everybody, from startups to enterprises</li>
                    </ul>
                </div>

                {/* CTA */}
                {/* <div className="text-center mt-16">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">Start FREE, Upgrade Anytime!</h3>
                    <p className="text-gray-600 mb-4">
                        Create your Attriva Live Chat account today and see how easy it is to support and convert your visitors.
                    </p>
                    <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition">
                        Get Started for Free
                    </button>
                </div> */}
            </div>

        </Layout>
    )
}

export default PricingPlan